import { memo, useState } from 'react';
import { IMenuItem } from 'models/IMenuItem';
import styles from './styles.scss';
import cn from 'classnames';
import { NotifyLink } from 'components/Shared/NotifyLink';
import SectionIcons from './sectionIcons';
import { useTouchStartNavigate } from 'components/MainMenu/useTouchStartNavigate';
import { CategoryContainer } from './categoryContainer';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { useDispatch } from 'react-redux';
import { GtmHeaderNavClick } from 'store/googleTagManager/actions';

const Title = memo(({ title }: IMenuItem) => {
  const [first, last] = (() => {
    const index = title.indexOf('&') + 1;
    return [title.substr(0, index), title.substr(index)];
  })();
  return (
    <span>
      {first}
      <br />
      {last}
    </span>
  );
});

interface OwnProps extends IMenuItem {
  openMenu: () => void;
  closeMenu: () => void;
  openId: string | undefined;
  isLoading: boolean;
  isParentOpen: boolean;
}
export const Section = ({
  openId,
  isLoading,
  isParentOpen,
  openMenu,
  closeMenu,
  ...item
}: OwnProps) => {
  const { id, url, ticket, subCategories } = item;
  const isOpen = isParentOpen && openId === id;
  const reduxDispatch = useDispatch();
  const [, setRef] = useTouchStartNavigate<HTMLAnchorElement | undefined>(useState(), {
    isLoading,
    isOpen,
    closeMenu,
    openMenu
  });

  const handleOnClick = () => {
    reduxDispatch(GtmHeaderNavClick(url));
  };

  return (
    <div
      className={cn(styles.section, { [styles.open]: isOpen })}
      onMouseOver={openMenu}
      onMouseOut={closeMenu}
    >
      <NotifyLink
        onClick={handleOnClick}
        url={url}
        ticket={ticket}
        setRef={setRef}
        {...getQaDataAttr(`link-nav-${id}`)}
      >
        <SectionIcons {...item} />
        <Title {...item} />
      </NotifyLink>
      <CategoryContainer
        isParentOpen={isOpen}
        isLoading={isLoading}
        subCategories={subCategories}
      />
    </div>
  );
};
